/**
 * The scene a scene config's `url` points the engine at: its path, without the slashes around it.
 * A version comparison's is `{projectId}/version-comparison/...`.
 */
export function parentSceneIdFromUrl(url: URL): string {
    return url.pathname.replace(/^\//, "").replace(/\/$/, "");
}

/** Whether a scene config's `url` is a version comparison's. */
export function isVersionComparisonSceneId(parentSceneId: string): boolean {
    return parentSceneId.includes("/version-comparison/");
}
